import {
  createCompanyRenderQuery,
  createCompanyPortalQueries
} from './lib/company-query-builder'

// Export for backward compatibility
export const companyPortalQueries = createCompanyPortalQueries({
  includeExecutives: true,
  layoutKey: 'company'
})

const createQuery = () => {
  return createCompanyRenderQuery({
    layoutKey: 'company',
    includePortalFields: true,
    includeExecutives: true
  })
}

export default createQuery
